export const SYS_ROLE = 0
export const PRJ_ROLE = 1